module.exports = __webpack_public_path__ + "static/media/4.13.6dbb2264.png";